<template>
  <!-- disclaimer  -->
  <g :transform="gTransform">
    <text style="font: 7px sans-serif" fill="dimgray" x="0" y="0">Consult your advisor for appropriate fertilizer recommendations.</text>
    <text style="font: 7px sans-serif" fill="dimgray" x="0" y="8"
      >Because Crop Health Labs has no effect and / or no control over the sampling, Crop Health Labs accepts no liability for adverse effects as a result of its analysis or advice provided.</text
    >
  </g>
</template>

<script>
export default {
  name: "pdf-disclaimer",
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    gTransform() {
      return `translate(${this.x},${this.y})`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>